var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_circle_svg__dr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 430,
    height: 430,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 430 430",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "add_circle_svg__ds",
    x1: 42.78,
    y1: 215,
    x2: 387.22,
    y2: 215,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4690ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2cd4f2"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "m215,387.22c-94.96,0-172.22-77.26-172.22-172.22,0-22.3,4.21-44.01,12.5-64.52h0c12.71-31.44,34.26-58.25,62.31-77.52,28.74-19.74,62.42-30.18,97.41-30.18,94.96,0,172.22,77.26,172.22,172.22s-77.26,172.22-172.22,172.22ZM66.4,154.98h0,0Z",
    style: {
      fill: "url(#add_circle_svg__ds)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.52,202.53h-52.04v-52.05c0-6.88-5.6-12.47-12.48-12.47s-12.47,5.6-12.47,12.47v52.05h-52.04c-6.88,0-12.48,5.6-12.48,12.48s5.6,12.47,12.48,12.47h52.04v52.04c0,6.88,5.6,12.48,12.47,12.48s12.48-5.6,12.48-12.48v-52.04h52.04c6.88,0,12.47-5.6,12.47-12.47s-5.6-12.48-12.47-12.48Z",
    style: {
      fill: "#f7f7f7"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCircle);
export default __webpack_public_path__ + "static/media/add_circle.6d6af1c928c04d2bf276afef53be028c.svg";
export { ForwardRef as ReactComponent };